const languageObj = {
  "HitPaw Online Audio Joiner": "موصل صوت عبر الإنترنت HitPaw",
  "Merge Audio": "دمج الصوت",
  "Merge multiple audio tracks into one.": "دمج مسارات صوتية متعددة في واحد.",
  "Merge New": "دمج جديد",
  "Merge failed": "فشل الدمج",
  "Fade in": "اختفي",
  "Fade out": "تتآكل",
  "Add tracks": "أضف المسارات",
  "Format": "صيغة",
};

export default languageObj